import { SVGProps } from 'react';

const SvgBandage = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 640 512"
    width="1em"
    height="1em"
    {...props}
  >
    <path d="M448 144v224h112c17.7 0 32-14.3 32-32V176c0-17.7-14.3-32-32-32H448zM192 96h368c44.2 0 80 35.8 80 80v160c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V176c0-44.2 35.8-80 80-80h112zm0 272V144H80c-17.7 0-32 14.3-32 32v160c0 17.7 14.3 32 32 32h112zm80-136a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0zM272 328a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0z" />
  </svg>
);
export default SvgBandage;
